<svg width="110" height="124" viewBox="0 0 110 124" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M0 34.0427H90.1282V89.9402C90.1282 92.7016 87.8896 94.9402 85.1282 94.9402H5C2.23858 94.9402 0 92.7016 0 89.9402V34.0427Z" fill="url(#paint0_linear_3812_5778)"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M0 9C0 6.23858 2.23858 4 5 4H85.1282C87.8896 4 90.1282 6.23858 90.1282 9V34.0427H0V9ZM30.0427 21.1111C30.0427 23.8017 27.8615 25.9829 25.1709 25.9829C22.4802 25.9829 20.2991 23.8017 20.2991 21.1111C20.2991 18.4205 22.4802 16.2393 25.1709 16.2393C27.8615 16.2393 30.0427 18.4205 30.0427 21.1111ZM65.7693 25.9829C68.4599 25.9829 70.6411 23.8017 70.6411 21.1111C70.6411 18.4205 68.4599 16.2393 65.7693 16.2393C63.0786 16.2393 60.8975 18.4205 60.8975 21.1111C60.8975 23.8017 63.0786 25.9829 65.7693 25.9829Z" fill="url(#paint1_linear_3812_5778)"/>
<rect x="15.4275" y="41.3503" width="11.5385" height="11.5385" rx="3" fill="url(#paint2_linear_3812_5778)"/>
<rect x="31.5813" y="41.3503" width="11.5385" height="11.5385" rx="3" fill="url(#paint3_linear_3812_5778)"/>
<rect x="47.7354" y="41.3503" width="11.5385" height="11.5385" rx="3" fill="url(#paint4_linear_3812_5778)"/>
<rect x="63.8892" y="41.3503" width="11.5385" height="11.5385" rx="3" fill="url(#paint5_linear_3812_5778)"/>
<rect x="15.4275" y="57.5043" width="11.5385" height="11.5385" rx="3" fill="url(#paint6_linear_3812_5778)"/>
<rect x="47.7354" y="57.5042" width="11.5385" height="11.5385" rx="5.76923" fill="url(#paint7_linear_3812_5778)"/>
<rect x="31.5813" y="57.5043" width="11.5385" height="11.5385" rx="3" fill="url(#paint8_linear_3812_5778)"/>
<rect x="63.8892" y="57.5043" width="11.5385" height="11.5385" rx="3" fill="url(#paint9_linear_3812_5778)"/>
<rect x="15.4275" y="73.6582" width="11.5385" height="11.5385" rx="3" fill="url(#paint10_linear_3812_5778)"/>
<rect x="47.7354" y="73.6581" width="11.5385" height="11.5385" rx="3" fill="url(#paint11_linear_3812_5778)"/>
<rect x="31.5813" y="73.6582" width="11.5385" height="11.5385" rx="3" fill="url(#paint12_linear_3812_5778)"/>
<rect x="63.8892" y="73.6582" width="11.5385" height="11.5385" rx="3" fill="url(#paint13_linear_3812_5778)"/>
<g filter="url(#filter0_i_3812_5778)">
<path fill-rule="evenodd" clip-rule="evenodd" d="M25.1709 29.2308C29.6553 29.2308 33.2906 25.5955 33.2906 21.1111C33.2906 16.6267 29.6553 12.9915 25.1709 12.9915C20.6866 12.9915 17.0513 16.6267 17.0513 21.1111C17.0513 25.5955 20.6866 29.2308 25.1709 29.2308ZM25.1709 25.9829C27.8615 25.9829 30.0427 23.8017 30.0427 21.1111C30.0427 18.4205 27.8615 16.2393 25.1709 16.2393C22.4802 16.2393 20.2991 18.4205 20.2991 21.1111C20.2991 23.8017 22.4802 25.9829 25.1709 25.9829Z" fill="url(#paint14_linear_3812_5778)"/>
</g>
<g filter="url(#filter1_i_3812_5778)">
<path fill-rule="evenodd" clip-rule="evenodd" d="M65.7693 29.2308C70.2537 29.2308 73.889 25.5955 73.889 21.1111C73.889 16.6267 70.2537 12.9915 65.7693 12.9915C61.285 12.9915 57.6497 16.6267 57.6497 21.1111C57.6497 25.5955 61.285 29.2308 65.7693 29.2308ZM65.7693 25.9829C68.4599 25.9829 70.6411 23.8017 70.6411 21.1111C70.6411 18.4205 68.4599 16.2393 65.7693 16.2393C63.0786 16.2393 60.8975 18.4205 60.8975 21.1111C60.8975 23.8017 63.0786 25.9829 65.7693 25.9829Z" fill="url(#paint15_linear_3812_5778)"/>
</g>
<g filter="url(#filter2_i_3812_5778)">
<rect x="22.7351" width="4.87179" height="18.6752" rx="2.4359" fill="url(#paint16_linear_3812_5778)"/>
</g>
<g filter="url(#filter3_i_3812_5778)">
<rect x="63.3333" width="4.87179" height="18.6752" rx="2.4359" fill="url(#paint17_linear_3812_5778)"/>
</g>
<path d="M69.2668 110.419L75.0624 111.973L73.5095 117.774C73.0807 119.376 71.4356 120.326 69.8352 119.897C68.2349 119.468 67.2851 117.821 67.7139 116.22L69.2668 110.419Z" fill="url(#paint18_linear_3812_5778)"/>
<path d="M89.9375 111.973L95.7331 110.419L97.286 116.22C97.7148 117.821 96.765 119.468 95.1646 119.897C93.5643 120.326 91.9192 119.376 91.4904 117.774L89.9375 111.973Z" fill="url(#paint19_linear_3812_5778)"/>
<g filter="url(#filter4_d_3812_5778)">
<path d="M74 64.0017C74 62.8962 74.8954 62 76 62H90C91.1046 62 92 62.8962 92 64.0017C92 65.1073 91.1046 66.0035 90 66.0035H85V67.0833C97.872 68.103 108 78.8808 108 92.0261C108 105.845 96.8071 117.048 83 117.048C69.1929 117.048 58 105.845 58 92.0261C58 78.8808 68.128 68.103 81 67.0833V66.0035H76C74.8954 66.0035 74 65.1073 74 64.0017Z" fill="url(#paint20_linear_3812_5778)"/>
</g>
<g filter="url(#filter5_i_3812_5778)">
<ellipse cx="83" cy="92.0261" rx="21" ry="21.0183" fill="url(#paint21_linear_3812_5778)"/>
</g>
<path d="M93.8585 110.02L72.8452 73.6241C75.8548 71.9569 79.3166 71.0078 83 71.0078C94.598 71.0078 104 80.418 104 92.0261C104 99.6568 99.9372 106.338 93.8585 110.02Z" fill="url(#paint22_linear_3812_5778)" fill-opacity="0.4" style="mix-blend-mode:screen"/>
<path d="M87.0304 112.658L67.1548 78.2323C71.0048 73.8058 76.6759 71.0079 83 71.0079C94.598 71.0079 104 80.4181 104 92.0262C104 102.255 96.7002 110.776 87.0304 112.658Z" fill="url(#paint23_linear_3812_5778)" fill-opacity="0.4" style="mix-blend-mode:screen"/>
<rect x="81" y="78.0139" width="4" height="14.0122" rx="2" fill="url(#paint24_linear_3812_5778)"/>
<rect x="70" y="94.0278" width="4.00348" height="16" rx="2.00174" transform="rotate(-90 70 94.0278)" fill="url(#paint25_linear_3812_5778)"/>
<ellipse cx="83" cy="92.0261" rx="4" ry="4.00348" fill="url(#paint26_linear_3812_5778)"/>
<path d="M84 75.0114C84 75.5641 83.5523 76.0122 83 76.0122C82.4477 76.0122 82 75.5641 82 75.0114C82 74.4586 82.4477 74.0105 83 74.0105C83.5523 74.0105 84 74.4586 84 75.0114Z" fill="url(#paint27_linear_3812_5778)"/>
<path d="M84 109.041C84 109.594 83.5523 110.042 83 110.042C82.4477 110.042 82 109.594 82 109.041C82 108.488 82.4477 108.04 83 108.04C83.5523 108.04 84 108.488 84 109.041Z" fill="url(#paint28_linear_3812_5778)"/>
<path d="M100 93.027C99.4477 93.027 99 92.5789 99 92.0262C99 91.4734 99.4477 91.0253 100 91.0253C100.552 91.0253 101 91.4734 101 92.0262C101 92.5789 100.552 93.027 100 93.027Z" fill="url(#paint29_linear_3812_5778)"/>
<path d="M66 93.027C65.4477 93.027 65 92.5789 65 92.0262C65 91.4734 65.4477 91.0253 66 91.0253C66.5523 91.0253 67 91.4734 67 92.0262C67 92.5789 66.5523 93.027 66 93.027Z" fill="url(#paint30_linear_3812_5778)"/>
<path d="M98.2224 84.3855C97.7441 84.6619 97.1325 84.4979 96.8563 84.0192C96.5802 83.5405 96.7441 82.9284 97.2224 82.652C97.7006 82.3756 98.3122 82.5396 98.5884 83.0183C98.8645 83.497 98.7006 84.1092 98.2224 84.3855Z" fill="url(#paint31_linear_3812_5778)"/>
<path d="M68.7775 101.4C68.2992 101.677 67.6876 101.513 67.4115 101.034C67.1354 100.555 67.2992 99.9432 67.7775 99.6668C68.2558 99.3904 68.8674 99.5544 69.1436 100.033C69.4197 100.512 69.2558 101.124 68.7775 101.4Z" fill="url(#paint32_linear_3812_5778)"/>
<path d="M92.3658 77.7914C92.0897 78.2701 91.4781 78.4341 90.9998 78.1577C90.5215 77.8813 90.3576 77.2692 90.6338 76.7905C90.9099 76.3118 91.5215 76.1478 91.9998 76.4242C92.4781 76.7005 92.642 77.3127 92.3658 77.7914Z" fill="url(#paint33_linear_3812_5778)"/>
<path d="M75.366 107.262C75.0898 107.741 74.4782 107.905 73.9999 107.628C73.5216 107.352 73.3578 106.74 73.6339 106.261C73.9101 105.782 74.5216 105.618 74.9999 105.895C75.4782 106.171 75.6421 106.783 75.366 107.262Z" fill="url(#paint34_linear_3812_5778)"/>
<path d="M97.2224 101.4C96.7441 101.124 96.5802 100.512 96.8563 100.033C97.1325 99.5544 97.7441 99.3904 98.2224 99.6668C98.7006 99.9432 98.8645 100.555 98.5884 101.034C98.3122 101.513 97.7006 101.677 97.2224 101.4Z" fill="url(#paint35_linear_3812_5778)"/>
<path d="M67.7775 84.3855C67.2992 84.1092 67.1354 83.497 67.4115 83.0183C67.6876 82.5396 68.2992 82.3756 68.7775 82.652C69.2558 82.9284 69.4197 83.5405 69.1436 84.0192C68.8674 84.4979 68.2558 84.6619 67.7775 84.3855Z" fill="url(#paint36_linear_3812_5778)"/>
<path d="M90.6339 107.262C90.3578 106.783 90.5216 106.171 90.9999 105.895C91.4782 105.618 92.0898 105.782 92.366 106.261C92.6421 106.74 92.4782 107.352 91.9999 107.628C91.5216 107.905 90.9101 107.741 90.6339 107.262Z" fill="url(#paint37_linear_3812_5778)"/>
<path d="M73.6339 77.7914C73.3578 77.3127 73.5216 76.7005 73.9999 76.4242C74.4782 76.1478 75.0898 76.3118 75.366 76.7905C75.6421 77.2692 75.4782 77.8813 74.9999 78.1577C74.5216 78.4341 73.9101 78.2701 73.6339 77.7914Z" fill="url(#paint38_linear_3812_5778)"/>
<defs>
<filter id="filter0_i_3812_5778" x="17.0513" y="11.9915" width="17.2393" height="17.2393" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dx="1" dy="-1"/>
<feGaussianBlur stdDeviation="1.5"/>
<feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"/>
<feBlend mode="multiply" in2="shape" result="effect1_innerShadow_3812_5778"/>
</filter>
<filter id="filter1_i_3812_5778" x="57.6497" y="11.9915" width="17.2393" height="17.2393" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dx="1" dy="-1"/>
<feGaussianBlur stdDeviation="1.5"/>
<feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"/>
<feBlend mode="multiply" in2="shape" result="effect1_innerShadow_3812_5778"/>
</filter>
<filter id="filter2_i_3812_5778" x="22.7351" y="-1" width="5.87177" height="19.6752" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dx="1" dy="-1"/>
<feGaussianBlur stdDeviation="1.5"/>
<feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"/>
<feBlend mode="multiply" in2="shape" result="effect1_innerShadow_3812_5778"/>
</filter>
<filter id="filter3_i_3812_5778" x="63.3333" y="-1" width="5.87177" height="19.6752" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dx="1" dy="-1"/>
<feGaussianBlur stdDeviation="1.5"/>
<feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"/>
<feBlend mode="multiply" in2="shape" result="effect1_innerShadow_3812_5778"/>
</filter>
<filter id="filter4_d_3812_5778" x="52" y="60" width="58" height="63.0479" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dx="-2" dy="2"/>
<feGaussianBlur stdDeviation="2"/>
<feComposite in2="hardAlpha" operator="out"/>
<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
<feBlend mode="multiply" in2="BackgroundImageFix" result="effect1_dropShadow_3812_5778"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_3812_5778" result="shape"/>
</filter>
<filter id="filter5_i_3812_5778" x="62" y="70.0078" width="43" height="43.0365" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dx="1" dy="-1"/>
<feGaussianBlur stdDeviation="1.5"/>
<feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"/>
<feBlend mode="multiply" in2="shape" result="effect1_innerShadow_3812_5778"/>
</filter>
<linearGradient id="paint0_linear_3812_5778" x1="2.49635e-08" y1="94.9402" x2="99.1582" y2="70.124" gradientUnits="userSpaceOnUse">
<stop stop-color="#D5D9E0"/>
<stop offset="1" stop-color="#F8F8FA"/>
</linearGradient>
<linearGradient id="paint1_linear_3812_5778" x1="2.32445e-07" y1="34.0427" x2="88.3552" y2="-0.531034" gradientUnits="userSpaceOnUse">
<stop stop-color="#24575B"/>
<stop offset="1" stop-color="#4CAABE"/>
</linearGradient>
<linearGradient id="paint2_linear_3812_5778" x1="15.4275" y1="52.8888" x2="28.2528" y2="51.2159" gradientUnits="userSpaceOnUse">
<stop stop-color="#24575B"/>
<stop offset="1" stop-color="#4CAABE"/>
</linearGradient>
<linearGradient id="paint3_linear_3812_5778" x1="31.5813" y1="52.8888" x2="44.4066" y2="51.2159" gradientUnits="userSpaceOnUse">
<stop stop-color="#24575B"/>
<stop offset="1" stop-color="#4CAABE"/>
</linearGradient>
<linearGradient id="paint4_linear_3812_5778" x1="47.7354" y1="52.8888" x2="60.5606" y2="51.2159" gradientUnits="userSpaceOnUse">
<stop stop-color="#24575B"/>
<stop offset="1" stop-color="#4CAABE"/>
</linearGradient>
<linearGradient id="paint5_linear_3812_5778" x1="63.8892" y1="52.8888" x2="76.7144" y2="51.2159" gradientUnits="userSpaceOnUse">
<stop stop-color="#24575B"/>
<stop offset="1" stop-color="#4CAABE"/>
</linearGradient>
<linearGradient id="paint6_linear_3812_5778" x1="15.4275" y1="69.0427" x2="28.2528" y2="67.3699" gradientUnits="userSpaceOnUse">
<stop stop-color="#24575B"/>
<stop offset="1" stop-color="#4CAABE"/>
</linearGradient>
<linearGradient id="paint7_linear_3812_5778" x1="47.7354" y1="69.0426" x2="60.85" y2="66.8249" gradientUnits="userSpaceOnUse">
<stop stop-color="#01040B"/>
<stop offset="1" stop-color="#565B66"/>
</linearGradient>
<linearGradient id="paint8_linear_3812_5778" x1="31.5813" y1="69.0427" x2="44.4066" y2="67.3699" gradientUnits="userSpaceOnUse">
<stop stop-color="#24575B"/>
<stop offset="1" stop-color="#4CAABE"/>
</linearGradient>
<linearGradient id="paint9_linear_3812_5778" x1="63.8892" y1="69.0427" x2="76.7144" y2="67.3699" gradientUnits="userSpaceOnUse">
<stop stop-color="#24575B"/>
<stop offset="1" stop-color="#4CAABE"/>
</linearGradient>
<linearGradient id="paint10_linear_3812_5778" x1="15.4275" y1="85.1967" x2="28.2528" y2="83.5238" gradientUnits="userSpaceOnUse">
<stop stop-color="#24575B"/>
<stop offset="1" stop-color="#4CAABE"/>
</linearGradient>
<linearGradient id="paint11_linear_3812_5778" x1="47.7354" y1="85.1965" x2="60.5606" y2="83.5237" gradientUnits="userSpaceOnUse">
<stop stop-color="#24575B"/>
<stop offset="1" stop-color="#4CAABE"/>
</linearGradient>
<linearGradient id="paint12_linear_3812_5778" x1="31.5813" y1="85.1967" x2="44.4066" y2="83.5238" gradientUnits="userSpaceOnUse">
<stop stop-color="#24575B"/>
<stop offset="1" stop-color="#4CAABE"/>
</linearGradient>
<linearGradient id="paint13_linear_3812_5778" x1="63.8892" y1="85.1967" x2="76.7144" y2="83.5238" gradientUnits="userSpaceOnUse">
<stop stop-color="#24575B"/>
<stop offset="1" stop-color="#4CAABE"/>
</linearGradient>
<linearGradient id="paint14_linear_3812_5778" x1="17.0513" y1="29.2308" x2="35.5089" y2="26.1096" gradientUnits="userSpaceOnUse">
<stop stop-color="#898F99"/>
<stop offset="1" stop-color="#D5D9E0"/>
</linearGradient>
<linearGradient id="paint15_linear_3812_5778" x1="57.6497" y1="29.2308" x2="76.1073" y2="26.1096" gradientUnits="userSpaceOnUse">
<stop stop-color="#898F99"/>
<stop offset="1" stop-color="#D5D9E0"/>
</linearGradient>
<linearGradient id="paint16_linear_3812_5778" x1="22.7351" y1="18.6752" x2="28.4197" y2="18.4244" gradientUnits="userSpaceOnUse">
<stop stop-color="#898F99"/>
<stop offset="1" stop-color="#D5D9E0"/>
</linearGradient>
<linearGradient id="paint17_linear_3812_5778" x1="63.3333" y1="18.6752" x2="69.0178" y2="18.4244" gradientUnits="userSpaceOnUse">
<stop stop-color="#898F99"/>
<stop offset="1" stop-color="#D5D9E0"/>
</linearGradient>
<linearGradient id="paint18_linear_3812_5778" x1="67.611" y1="120" x2="76.1743" y2="118.874" gradientUnits="userSpaceOnUse">
<stop stop-color="#01040B"/>
<stop offset="1" stop-color="#565B66"/>
</linearGradient>
<linearGradient id="paint19_linear_3812_5778" x1="89.9375" y1="120" x2="98.5009" y2="118.874" gradientUnits="userSpaceOnUse">
<stop stop-color="#01040B"/>
<stop offset="1" stop-color="#565B66"/>
</linearGradient>
<linearGradient id="paint20_linear_3812_5778" x1="58" y1="117.048" x2="115.108" y2="108.276" gradientUnits="userSpaceOnUse">
<stop stop-color="#01040B"/>
<stop offset="1" stop-color="#565B66"/>
</linearGradient>
<linearGradient id="paint21_linear_3812_5778" x1="62" y1="113.044" x2="109.739" y2="104.979" gradientUnits="userSpaceOnUse">
<stop stop-color="#898F99"/>
<stop offset="1" stop-color="#D5D9E0"/>
</linearGradient>
<linearGradient id="paint22_linear_3812_5778" x1="104" y1="71.0078" x2="65.954" y2="101.391" gradientUnits="userSpaceOnUse">
<stop stop-color="white"/>
<stop offset="1" stop-color="white" stop-opacity="0"/>
</linearGradient>
<linearGradient id="paint23_linear_3812_5778" x1="104" y1="71.0079" x2="62.6611" y2="107.578" gradientUnits="userSpaceOnUse">
<stop stop-color="white"/>
<stop offset="1" stop-color="white" stop-opacity="0"/>
</linearGradient>
<linearGradient id="paint24_linear_3812_5778" x1="81" y1="92.0261" x2="85.6655" y2="91.8009" gradientUnits="userSpaceOnUse">
<stop stop-color="#01040B"/>
<stop offset="1" stop-color="#565B66"/>
</linearGradient>
<linearGradient id="paint25_linear_3812_5778" x1="70" y1="110.028" x2="74.6721" y2="109.83" gradientUnits="userSpaceOnUse">
<stop stop-color="#01040B"/>
<stop offset="1" stop-color="#565B66"/>
</linearGradient>
<linearGradient id="paint26_linear_3812_5778" x1="79" y1="96.0295" x2="88.0932" y2="94.4932" gradientUnits="userSpaceOnUse">
<stop stop-color="#01040B"/>
<stop offset="1" stop-color="#565B66"/>
</linearGradient>
<linearGradient id="paint27_linear_3812_5778" x1="65" y1="110.042" x2="105.92" y2="103.128" gradientUnits="userSpaceOnUse">
<stop stop-color="#01040B"/>
<stop offset="1" stop-color="#565B66"/>
</linearGradient>
<linearGradient id="paint28_linear_3812_5778" x1="65" y1="110.042" x2="105.92" y2="103.128" gradientUnits="userSpaceOnUse">
<stop stop-color="#01040B"/>
<stop offset="1" stop-color="#565B66"/>
</linearGradient>
<linearGradient id="paint29_linear_3812_5778" x1="65" y1="110.042" x2="105.92" y2="103.128" gradientUnits="userSpaceOnUse">
<stop stop-color="#01040B"/>
<stop offset="1" stop-color="#565B66"/>
</linearGradient>
<linearGradient id="paint30_linear_3812_5778" x1="65" y1="110.042" x2="105.92" y2="103.128" gradientUnits="userSpaceOnUse">
<stop stop-color="#01040B"/>
<stop offset="1" stop-color="#565B66"/>
</linearGradient>
<linearGradient id="paint31_linear_3812_5778" x1="65" y1="110.042" x2="105.92" y2="103.128" gradientUnits="userSpaceOnUse">
<stop stop-color="#01040B"/>
<stop offset="1" stop-color="#565B66"/>
</linearGradient>
<linearGradient id="paint32_linear_3812_5778" x1="65" y1="110.042" x2="105.92" y2="103.128" gradientUnits="userSpaceOnUse">
<stop stop-color="#01040B"/>
<stop offset="1" stop-color="#565B66"/>
</linearGradient>
<linearGradient id="paint33_linear_3812_5778" x1="65" y1="110.042" x2="105.92" y2="103.128" gradientUnits="userSpaceOnUse">
<stop stop-color="#01040B"/>
<stop offset="1" stop-color="#565B66"/>
</linearGradient>
<linearGradient id="paint34_linear_3812_5778" x1="65" y1="110.042" x2="105.92" y2="103.128" gradientUnits="userSpaceOnUse">
<stop stop-color="#01040B"/>
<stop offset="1" stop-color="#565B66"/>
</linearGradient>
<linearGradient id="paint35_linear_3812_5778" x1="65" y1="110.042" x2="105.92" y2="103.128" gradientUnits="userSpaceOnUse">
<stop stop-color="#01040B"/>
<stop offset="1" stop-color="#565B66"/>
</linearGradient>
<linearGradient id="paint36_linear_3812_5778" x1="65" y1="110.042" x2="105.92" y2="103.128" gradientUnits="userSpaceOnUse">
<stop stop-color="#01040B"/>
<stop offset="1" stop-color="#565B66"/>
</linearGradient>
<linearGradient id="paint37_linear_3812_5778" x1="65" y1="110.042" x2="105.92" y2="103.128" gradientUnits="userSpaceOnUse">
<stop stop-color="#01040B"/>
<stop offset="1" stop-color="#565B66"/>
</linearGradient>
<linearGradient id="paint38_linear_3812_5778" x1="65" y1="110.042" x2="105.92" y2="103.128" gradientUnits="userSpaceOnUse">
<stop stop-color="#01040B"/>
<stop offset="1" stop-color="#565B66"/>
</linearGradient>
</defs>
</svg>
